export default "__VITE_PUBLIC_ASSET__193764b9__"